import React from "react";
import useAuth from "../hooks/useAuth.js";
import searchIcon from "../assets/search-icon.svg";
import userIcon from "../assets/uil_user.svg";
import { useWindowManager } from './../hooks/useWindowManager';
import axiosInstance from '../utilities/axiosInstance';
import enLogo from "../assets/tagi5-final-logo.png";
import enSLogo from "../assets/Tagi5-short-logo.png";
import { useSearch } from '../context/SearchContext.js';
import { useTheme } from '../context/ThemeContext';
import { GrPower } from "react-icons/gr";
import { CgDarkMode } from "react-icons/cg";
import { TbArrowBarRight, TbArrowBarLeft } from "react-icons/tb";
import { MdOutlineArrowBackIos } from "react-icons/md";



function SearchBar({ isSidebarOpen, toggleSidebar }) {
  const { setSearchValue } = useSearch();
  const { auth, setAuth } = useAuth();
  const { logout } = useWindowManager();
  const { isDark, setIsDark } = useTheme();
  
  const resetAuth = () => {
    let profile_id = auth.profile_id;
    axiosInstance.put(`/logout/${profile_id}`, { profil_login_session: 0 })
    setAuth({});
    //localStorage.removeItem('token');
  };
  
  return (
    <div className="flex flex-row items-center justify-between h-[75px] rounded-[18px] pl-[20px] pr-[17px] relative z-10 transition-all duration-300 ease-in-out">
      <div className="flex flex-row items-center transition-all duration-300 ease-in-out">
        <div className={`${isSidebarOpen ? 'w-[248px]' : 'w-[80px]'} flex items-center justify-between gap-3 min-w-[80px]`}>
          <img src={isSidebarOpen ? enLogo : enSLogo} alt='logo' className={`${isSidebarOpen ? 'w-[118px] h-[30px]' : 'w-[35px] h-auto'} transition-all duration-300 ease-in-out`} />

          {/* Collapse Button */}
          <button
            onClick={toggleSidebar}
            className="w-[30px] h-[30px] text-base min-w-[30px] rounded-[22px] bg-gradient-to-r from-[#C300A0] to-[#00B4D2] flex items-center justify-center text-white transition-transform duration-200 hover:scale-110 hover:shadow-lg"
          >
            <MdOutlineArrowBackIos className={`transition-all duration-300 ease-in-out ${isSidebarOpen ? "rotate-180" : ''}`} />
          </button>
        </div>
        <h3 className="font-poppins text-gray-main font-semibold text-[19px] pl-[10px] leading-[100%] tracking-[0%] mr-[50px] dark:text-white">
          Tagi5
        </h3>
        <div className="relative w-[450px]">
          <img
            src={searchIcon}
            alt="Search Icon"
            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500 dark:text-gray-400"
          />
          <input
            type="search"
            onChange={(e) => setSearchValue(e.target.value)}
            placeholder="Search by username"
            className="w-full h-[35px] rounded-[21px] pl-10 pr-4 py-[7px] border border-gray-400 bg-transparent text-gray-800 dark:text-gray-400 placeholder-gray-500 
               focus:outline-none focus:border-[#00B4D2] focus:shadow-[0px_3px_8.6px_0px_#00B4D233]"
          />
        </div>
      </div>

      <div className="flex items-center gap-[10px] px-4 py-2">
        {/* Dark Theme Toggle Icon with Tooltip */}
        <div className="relative group flex items-center">
          <button
            onClick={() => setIsDark(!isDark)}
            className="text-[#3C3C3C] hover:text-[#00B4D2] focus:outline-none dark:text-white"
          >
            <span className="text-2xl">
              <CgDarkMode />
            </span>
          </button>
          <p className="absolute w-40 top-8 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity">
            <span className="block dark:hidden">Switch to Dark Mode</span>
            <span className="hidden dark:block">Switch to light Mode</span>
          </p>
        </div>
        {/* Profile Image */}
        <div className="w-[30px] h-[30px] min-w-[30px] min-h-[30px] p-[3px_5px] bg-[#28325A26] dark:bg-gray-400 rounded-[17px] flex items-center justify-center">
          <img
            src={userIcon}
            alt="Profile"
            className="w-[18px] h-[18px] object-contain"
          />
        </div>

        {/* Profile Name */}
        <p className="font-[Poppins] font-medium text-[16px] leading-[16px] text-secondary-color mr-[43px] capitalize dark:text-white">
          {auth.profile_username}
        </p>

        {/* Logout Icon Button with Tooltip */}
        <div className="relative group">
          <button
            onClick={() => {
              logout();
              resetAuth();
            }}
            className="text-[#3C3C3C] hover:text-red-500 focus:outline-none text-2xl dark:text-white"
          >
            <GrPower />
          </button>
          <span className="absolute top-8 left-1/2 transform -translate-x-1/2 bg-gray-700 text-white text-xs rounded py-1 px-2 opacity-0 group-hover:opacity-100 transition-opacity">
            Logout
          </span>
        </div>
      </div>
    </div>
  );
}

export default SearchBar;
